import { keys } from 'lodash';
import { removeExtra } from './timePeriods';

const setFirstAsSelected = arr =>
    arr.map((item, index) => (index ? item : { ...item, selected: true }));

export const setSelected = (arr, value) => {
    const mappedArray = arr.map(item =>
        (item.value === value ? { ...item, selected: true } : item)
    );

    return mappedArray.find(option => option.selected)
        ? mappedArray
        : setFirstAsSelected(mappedArray);
};

export const getOption = (categories, categoryName) =>
    categories[categoryName].options.find(item => item.selected);

export const getOptions = categories =>
    keys(categories).reduce((result, key) => ({
        ...result,
        [key]: getOption(categories, key),
    }), {});

export const getCaption = (...args) =>
    getOption(...args).label;

export const getCaptions = (categories) => {
    const selectedOptions = getOptions(categories);
    return keys(categories).reduce((result, key) => ({
        ...result,
        [key]: selectedOptions[key].label,
    }), {});
};

export const getValueWithSuffix = (...args) => getOption(...args).value;

export const getValue = (...args) =>
    removeExtra(getOption(...args).value);

export const getValues = (categories) => {
    const selectedOptions = getOptions(categories);
    return keys(categories).reduce((result, key) => ({
        ...result,
        [key]: removeExtra(selectedOptions[key].value),
    }), {});
};

export const hasValue = (categories, value) => (
    categories.options.some(option => value === option.value)
);




// WEBPACK FOOTER //
// ./src/js/utils/filter/selection.js